module.exports = __webpack_public_path__ + "img/business_18.3b883b28.jpg";